import UserModalStore from "core/stores/user-modal.store";
import UserDetailsWrapper from "../user-details-wrapper";

type UserCardType = {
    users: UserDetailsWrapper[],
    isPendingUsers?: boolean
    modalStore?: UserModalStore | null
}

const UserCards = ({ users, isPendingUsers = false, modalStore = null }: UserCardType) => {
    if (!users.length) {
        return null;
    }

    const editClick = (userDetail: any) => {
        const store = modalStore as UserModalStore;

        store.updateDisplay(true);
        store.updateUser(userDetail);
        store.updateIsUpdate(true);
    }

    const useTestData = false;
    const defaultValue = useTestData ? "Test Data" : "";

    return (
        <ul className="cards">
            {users.map((userDetail: UserDetailsWrapper, index: number) => {
                return (
                    <li key={index}>
                        {
                            !isPendingUsers &&
                            <button onClick={() => editClick(userDetail)}>
                                <i className="icon-Arrow_right_thin"></i>
                            </button>
                        }

                        <h4>{userDetail.fullName ?? defaultValue}</h4>
                        <h5>{userDetail.role ?? defaultValue}</h5>

                        <p>
                            {userDetail.mobileNumber ?? defaultValue}<br />
                            {userDetail.email ?? defaultValue}<br />
                            <strong>Financial Authorisation: </strong>
                            {
                                userDetail.financialAuth
                                    ? <em>Yes</em>
                                    : <em className="no">No</em>
                            }
                        </p>
                    </li>);
            })}
        </ul>
    );
}

export default UserCards;
